(function () {
  'use strict';

  if (window.PGKlaviyoScrollGuardV32) return;
  window.PGKlaviyoScrollGuardV32 = true;

  var open = false;
  var openedAt = 0;
  var savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var timer = null;
  var observer = null;
  var instantClickBound = false;

  var CORE = [
    '.klaviyo-form',
    '[class*="klaviyo"]',
    '[id*="klaviyo"]',
    '[class*="kl-private-reset-css"]',
    'iframe[src*="klaviyo"]'
  ].join(',');

  var HINTS = CORE + ',[data-testid="POPUP"],[data-testid="FLYOUT"]';

  function text(value) {
    return String(value || '').toLowerCase();
  }

  function visible(element) {
    if (!element || !element.getBoundingClientRect) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.02 &&
      rect.width > 1 &&
      rect.height > 1 &&
      rect.right > 1 &&
      rect.left < window.innerWidth - 1 &&
      rect.bottom > 1 &&
      rect.top < window.innerHeight - 1;
  }

  function hasCoreHint(element) {
    var current = element;
    var depth = 0;

    while (current && current.nodeType === 1 && depth < 8) {
      var hint = text([
        current.id,
        typeof current.className === 'string' ? current.className : '',
        current.getAttribute('src')
      ].filter(Boolean).join(' '));

      if (/klaviyo|kl-private-reset-css/.test(hint)) return true;
      current = current.parentElement;
      depth += 1;
    }

    return Boolean(element && element.querySelector && element.querySelector(CORE));
  }

  function modalLike(element) {
    if (!element || !element.getBoundingClientRect) return false;

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    var area = Math.max(0, rect.width * rect.height);
    var viewport = Math.max(1, window.innerWidth * window.innerHeight);
    var z = parseInt(style.zIndex || '0', 10);

    return text(element.getAttribute('role')) === 'dialog' ||
      text(element.getAttribute('aria-modal')) === 'true' ||
      /popup|flyout/.test(text(element.getAttribute('data-testid'))) ||
      ((style.position === 'fixed' || style.position === 'sticky') &&
        (area >= viewport * 0.06 || (Number.isFinite(z) && z >= 900)));
  }

  function popupRoot() {
    var hints;

    try {
      hints = document.querySelectorAll(HINTS);
    } catch (error) {
      return null;
    }

    for (var index = 0; index < hints.length; index += 1) {
      var hint = hints[index];
      var testId = text(hint.getAttribute && hint.getAttribute('data-testid'));
      var current = hint;
      var root = null;
      var depth = 0;

      while (current && current.nodeType === 1 && depth < 10) {
        if (modalLike(current)) root = current;
        current = current.parentElement;
        depth += 1;
      }

      if (root && visible(root) && (hasCoreHint(root) || /popup|flyout/.test(testId))) return root;
      if (visible(hint) && modalLike(hint) && (hasCoreHint(hint) || /popup|flyout/.test(testId))) return hint;
    }

    return null;
  }

  function markPopup(root) {
    if (!root) return;

    if (root.getAttribute('data-pg-klaviyo-open') !== 'v32') {
      root.setAttribute('data-pg-klaviyo-open', 'v32');
    }
    if (!root.hasAttribute('role')) root.setAttribute('role', 'dialog');
    if (!root.hasAttribute('aria-hidden')) root.setAttribute('aria-hidden', 'false');
  }

  function cartOpen() {
    var drawer = document.querySelector('.cart_content, #pg-cart, .pg-mobile-drawer');
    if (!drawer) return false;

    if (document.querySelector(
      '.mini_cart.active_link, .mini_cart.is-active, .mini_cart[aria-expanded="true"], ' +
      '.pg-mobile-drawer.pg-open, #pg-cart.open, #pg-cart.is-active, [data-cart-drawer][data-open="true"]'
    )) return true;

    return drawer.getAttribute('aria-hidden') === 'false' ||
      drawer.matches('.active, .is-active, .active_link, .open, .pg-open, [data-open="true"]') ||
      visible(drawer);
  }

  function otherOverlayOpen() {
    if (document.querySelector('details[data-mobile-menu][open]')) return true;

    var nodes = document.querySelectorAll([
      '[role="dialog"]',
      '[aria-modal="true"]',
      '.modal.is-active',
      '.modal.active',
      '.modal.open',
      '.fancybox-container.fancybox-is-open',
      '.quick-shop.active',
      '.quick-shop.is-active',
      '.search-container.is-active',
      '.search-container.active',
      '.age-gate.is-active',
      '[data-mobile-menu].is-open',
      '[data-mobile-menu].active'
    ].join(','));

    for (var index = 0; index < nodes.length; index += 1) {
      if (nodes[index].hasAttribute('data-pg-klaviyo-open') || hasCoreHint(nodes[index])) continue;
      if (visible(nodes[index])) return true;
    }

    return false;
  }

  function locked() {
    var html = document.documentElement;
    var body = document.body;
    if (!body) return false;

    var bodyStyle = window.getComputedStyle(body);
    var htmlStyle = window.getComputedStyle(html);
    var classes = text(body.className + ' ' + html.className);

    return bodyStyle.position === 'fixed' ||
      htmlStyle.position === 'fixed' ||
      /^(hidden|clip)$/.test(bodyStyle.overflow) ||
      /^(hidden|clip)$/.test(bodyStyle.overflowY) ||
      /^(hidden|clip)$/.test(htmlStyle.overflow) ||
      /^(hidden|clip)$/.test(htmlStyle.overflowY) ||
      /blocked-scroll|overflow-hidden|no-scroll|modal-open|pg-drawer-open|klaviyo[^ ]*(?:open|lock|modal)/.test(classes);
  }

  function scrollY() {
    var bodyTop = document.body && parseInt(document.body.style.top || '0', 10);
    var htmlTop = parseInt(document.documentElement.style.top || '0', 10);

    if (Number.isFinite(bodyTop) && bodyTop < 0) return Math.abs(bodyTop);
    if (Number.isFinite(htmlTop) && htmlTop < 0) return Math.abs(htmlTop);
    return savedY || window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function removeLockClasses(element) {
    if (!element || !element.classList) return;

    Array.prototype.slice.call(element.classList).forEach(function (name) {
      if (
        /^(blocked-scroll|overflow-hidden|no-scroll|modal-open|pg-drawer-open)$/i.test(name) ||
        /^klaviyo.*(?:open|lock|modal|scroll)/i.test(name) ||
        /^(?:disable|disabled|lock|locked)[-_]?scroll$/i.test(name)
      ) element.classList.remove(name);
    });
  }

  function clearInlineLock(element) {
    if (!element) return;

    var style = window.getComputedStyle(element);
    var fixed = style.position === 'fixed' || element.style.position === 'fixed';
    var hidden = /^(hidden|clip)$/.test(style.overflow) || /^(hidden|clip)$/.test(style.overflowY);

    if (hidden) {
      element.style.removeProperty('overflow');
      element.style.removeProperty('overflow-y');
    }
    if (fixed) {
      ['position', 'top', 'left', 'right', 'width', 'height'].forEach(function (property) {
        element.style.removeProperty(property);
      });
    }
    if (style.touchAction === 'none' || element.style.touchAction === 'none') {
      element.style.removeProperty('touch-action');
    }
  }

  function unlock() {
    var popup = popupRoot();

    if (popup) {
      open = true;
      markPopup(popup);
      return;
    }

    if (open && Date.now() - openedAt < 450) {
      schedule(500 - (Date.now() - openedAt));
      return;
    }

    open = false;
    document.documentElement.removeAttribute('data-pg-klaviyo-open');

    if (cartOpen() || otherOverlayOpen() || !locked()) return;

    var y = scrollY();
    removeLockClasses(document.body);
    removeLockClasses(document.documentElement);
    clearInlineLock(document.body);
    clearInlineLock(document.documentElement);

    window.requestAnimationFrame(function () {
      window.scrollTo(0, y);
      savedY = y;
      window.dispatchEvent(new Event('resize'));
      document.dispatchEvent(new CustomEvent('pg:klaviyo-unlocked', {
        detail: { source: 'pg-klaviyo-scroll-guard-v32' }
      }));
    });
  }

  function reconcile() {
    timer = null;
    var popup = popupRoot();

    if (popup) {
      if (!open) {
        savedY = window.pageYOffset || document.documentElement.scrollTop || savedY;
        openedAt = Date.now();
      }
      open = true;
      if (document.documentElement.getAttribute('data-pg-klaviyo-open') !== 'v32') {
        document.documentElement.setAttribute('data-pg-klaviyo-open', 'v32');
      }
      markPopup(popup);
      return;
    }

    unlock();
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, delay == null ? 80 : Math.max(20, delay));
  }

  function closePasses() {
    [60, 140, 300, 600, 1000, 1800].forEach(function (delay) {
      window.setTimeout(unlock, delay);
    });
  }

  function formEvent(event) {
    var detail = event && event.detail || {};
    var type = text(detail.type || detail.event || detail.action);

    if (/^(open|show|shown)$/.test(type)) {
      savedY = window.pageYOffset || document.documentElement.scrollTop || savedY;
      open = true;
      openedAt = Date.now();
      schedule(20);
    } else if (/^(close|closed|hide|hidden)$/.test(type)) {
      open = false;
      closePasses();
    }
  }

  function bindInstantClick(attempt) {
    if (instantClickBound) return;

    if (window.InstantClick && typeof window.InstantClick.on === 'function') {
      instantClickBound = true;
      window.InstantClick.on('change', function () {
        open = false;
        closePasses();
      });
    } else if ((attempt || 0) < 20) {
      window.setTimeout(function () { bindInstantClick((attempt || 0) + 1); }, 250);
    }
  }

  function init() {
    window.addEventListener('klaviyoForms', formEvent);
    document.addEventListener('klaviyoForms', formEvent);

    window.addEventListener('scroll', function () {
      if (!open && !locked()) savedY = window.pageYOffset || document.documentElement.scrollTop || savedY;
    }, { passive: true });

    window.addEventListener('pageshow', closePasses, { passive: true });
    window.addEventListener('popstate', closePasses, { passive: true });
    window.addEventListener('hashchange', closePasses, { passive: true });

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest(HINTS)) closePasses();
    }, true);

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') closePasses();
    });

    if (window.MutationObserver) {
      observer = new MutationObserver(function () { schedule(70); });
      observer.observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'aria-hidden', 'aria-modal', 'role', 'data-testid']
      });
    }

    bindInstantClick(0);
    schedule(20);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
